const scrollTo = (target) => {
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -64, duration: 1.4 });
  else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
};

export const Masthead = () => (
  <header
    data-testid="masthead"
    className="fixed top-0 left-0 right-0 z-50 border-b border-ink/15 bg-paper/85 backdrop-blur-md"
  >
    <div className="flex items-center justify-between px-4 sm:px-8 h-14">
      <button
        data-testid="masthead-home-link"
        onClick={() => scrollTo("#top")}
        className="font-mono text-xs font-bold tracking-[0.18em] uppercase hover:text-salsa transition-colors"
      >
        Pranjal's Taco Spots
      </button>
      <span className="hidden md:block font-mono text-[10px] tracking-[0.22em] uppercase text-muted2">
        Field Report No. 001 — Austin, Texas
      </span>
      <nav className="flex items-center gap-4 sm:gap-6">
        {[
          ["The Index", "#the-index", "nav-index-link"],
          ["Map", "#the-map", "nav-map-link"],
          ["Findings", "#the-findings", "nav-findings-link"],
          ["Standard", "#the-standard", "nav-standard-link"],
        ].map(([label, target, tid]) => (
          <button
            key={tid}
            data-testid={tid}
            onClick={() => scrollTo(target)}
            className="font-mono text-[10px] sm:text-[11px] tracking-[0.16em] uppercase hover:text-salsa transition-colors"
          >
            {label}
          </button>
        ))}
      </nav>
    </div>
  </header>
);

export default Masthead;
